import Api from "network/api/api.service";
import { ENTITIES } from "network/models/entities";
import QueryUtil from "utils/query.util";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { IFamily } from "network/models/family.model";
import { message } from "antd";

export function useGetFamilies({
  page,
  limit,
}: {
  page: number;
  limit: number;
}) {
  const query = useQuery([ENTITIES.GET_ALL_FAMILIES], () =>
    Api.instance.getAllFamilies({ page, limit })
  );
  return QueryUtil.processSingleDataGetQuery(query as any);
}

export function useGetFamily(id: string) {
  const query = useQuery([ENTITIES.GET_FAMILY, id], () =>
    Api.instance.getFamily(id)
  );
  return QueryUtil.processSingleDataGetQuery(query as any);
}

export function useCreateFamily() {
  const queryClient = useQueryClient();
  const query = useMutation(
    [ENTITIES.CREATE_FAMILY],
    (payload: IFamily) => Api.instance.createFamily(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENTITIES.GET_ALL_FAMILIES]);
        message.success("تم إضافة العائلة بنجاح ✅");
      },
      onError: () => {
        message.error("حدث خطأ غير متوقع، يرجى المحاولة لاحقًا");
      },
    }
  );
  return query;
}

export function useUpdateFamily() {
  const queryClient = useQueryClient();
  const query = useMutation(
    [ENTITIES.UPDATE_FAMILY],
    (payload: IFamily) => Api.instance.updateFamily(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENTITIES.GET_ALL_FAMILIES]);
        message.success("تم تحديث بيانات العائلة بنجاح ✅");
      },
      onError: () => {
        message.error("حدث خطأ غير متوقع، يرجى المحاولة لاحقًا");
      },
    }
  );
  return query;
}

export function useDeleteFamily() {
  const query = useMutation(
    [ENTITIES.DELETE_FAMILY],
    (id: string) => Api.instance.deleteFamily(id),
    {
      onSuccess: () => {
        message.success("تم حذف العائلة بنجاح ✅");
      },
      onError: () => {
        message.error("حدث خطأ غير متوقع، يرجى المحاولة لاحقًا");
      },
    }
  );
  return query;
}
